import type { NextPage } from 'next';
import styles from './hero-block.module.scss';
import BlogBookingForm from './components/BlogBookingForm/BlogBookingForm';
import { HeroBlockType } from '@/types/heroBlock.types';

const HeroBlockBlog: NextPage<HeroBlockType> = ({
  className = '',
  device = 'Default',
  form = 'On',
  showForm = true,
  title = "Discover the World's Most Amazing Places",
  description = 'Private Jet Charter Flights & More',
  backgroundImage = '/img/heroBlock/bg.webp',
}) => {
  return (
    <section
      className={[styles.heroblock, className].join(' ')}
      data-device={device}
      data-form={form}
      data-show-form={showForm}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="container">
        <div className={styles.herocontainer}>
          <div className={styles.text}>
            <h1 className={styles.title}>{title}</h1>
            <h2 className={styles.deskriptor}>{description}</h2>
          </div>
          {showForm && <BlogBookingForm />}
        </div>
      </div>
    </section>
  );
};

export default HeroBlockBlog;
